import axios from '@/libs/axios'

export default {
  getConfig() {
    return axios.get('/api/stripe-payment/pix/config')
  },
  requestPayment(data) {
    return axios.post('/api/stripe-payment/pix/request-payment', data)
  },
  getTransaction(id) {
    return axios.get(`/api/stripe-payment/pix/transactions/${encodeURIComponent(id)}`)
  },
  getPendingTransaction() {
    return axios.get('/api/stripe-payment/pix/transactions/pending')
  },
  cancelTransaction(id) {
    return axios.post(`/api/stripe-payment/pix/transactions/${encodeURIComponent(id)}/cancel`)
  },
}
